/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_TitleInputs */

const en_tx_title = /** @type {(inputs: Tx_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transactions`)
};

const id_tx_title = /** @type {(inputs: Tx_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaksi`)
};

/**
* | output |
* | --- |
* | "Transactions" |
*
* @param {Tx_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_title = /** @type {((inputs?: Tx_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_title(inputs)
	return en_tx_title(inputs)
});